/* Native <dialog> lightbox for a lp-reasons reason_image block's full-size
   image (sections/lp-reasons.liquid, settings.open_full_image). Deliberately
   thin, same spirit as assets/lp-buy.js: Esc-to-close, the focus trap and
   returning focus to the trigger button on close are all native
   <dialog>/showModal() behavior, not reimplemented here. */
class LpReasonsLightbox extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-lp-reasons-lightbox-open]');
    this.dialog = this.querySelector('[data-lp-reasons-lightbox]');
    this.closeButton = this.querySelector('[data-lp-reasons-lightbox-close]');
    if (!this.trigger || !this.dialog) return;

    this.onTriggerClick = () => this.dialog.showModal();
    this.onCloseClick = () => this.dialog.close();
    // A click that lands on the dialog's own ::backdrop (outside its content
    // box) is dispatched with the <dialog> itself as event.target -- a click
    // on any real descendant (the close button, the image) sets target to
    // that descendant instead, so this only ever closes on an actual
    // backdrop click, never a click inside the dialog's own content.
    this.onDialogClick = (event) => {
      if (event.target === this.dialog) this.dialog.close();
    };

    this.trigger.addEventListener('click', this.onTriggerClick);
    this.dialog.addEventListener('click', this.onDialogClick);
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.onCloseClick);
    }
  }

  disconnectedCallback() {
    if (!this.trigger || !this.dialog) return;
    this.trigger.removeEventListener('click', this.onTriggerClick);
    this.dialog.removeEventListener('click', this.onDialogClick);
    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this.onCloseClick);
    }
  }
}

if (!customElements.get('lp-reasons-lightbox')) {
  customElements.define('lp-reasons-lightbox', LpReasonsLightbox);
}
